module.exports = __webpack_public_path__ + "static/media/delete.e0e4dcaf.svg";